<template>
    <div
        v-if="attributesData.length"
    >
        <div
            v-for="(attr) in attributesData"
            :key="attr.key"
            :class="`af-attribute-filter-${attr.key} af-attribute-filter afu-my-4 afu-pt-5 afu-pb-2 afu-px-4 afu-shadow-secondary afu-rounded-secondary afu-border-neutral-light afu-bg-neutral-light`"
        >
            <C1Label
                class="afu-mb-3 afu-text-secondary afu-text-5xl afu-uppercase afu-font-bold afu-tracking-widest"
            >
                <span class="af-text--5xl afu-uppercase afu-font-bold afu-tracking-widest">{{ attr.label }}</span>
            </C1Label>

            <ul class="afu-m-0 afu-p-0 afu-list-none">
                <li
                    v-for="(attrOp, index) in attr.attributeOptions"
                    :key="`${attrOp.id}_${index}`"
                    class="afu-text-base afu-text-black afu-mb-3 afu-flex afu-items-center"
                >
                    <div
                        class="afu-cursor-pointer afu-flex afu-items-center"
                        @click="onSelect(attr.key, attrOp)"
                    >
                        <div class="afu-text-lg">
                            <FontAwesomeIcon
                                v-if="attrOp.is_selected"
                                :icon="['fas', 'check-square']"
                                class="afu-mr-2 afu-text-secondary fa-w-16"
                            />
                            <FontAwesomeIcon
                                v-else
                                :icon="['far', 'square']"
                                class="afu-mr-2 afu-text-secondary fa-w-16"
                            />
                        </div>

                        <div class="afu-text-sm afu-text-inherit">
                            <span
                                class="cls-item-label-text afu-text-inherit"
                            >
                                {{ attrOp.value }}
                            </span>
                            <span
                                class="cls-item-count"
                                v-if="showTaxonomyCount"
                            >
                                ({{ attrOp.count | numeral }})
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    import numeral from 'numeral';
    import C1Label from '@/components/C1Components/C1Label';
    // import SearchMixin from  '@/apps/search/001/components/Mixins/SearchMixin.vue';

    export default {
        name: 'CustomAttributeFilter',

        // mixins: [SearchMixin],

        filters: {
            numeral(value) {
                if (!value) { return; }
                return numeral(value).format('0,0');
            },
        },

        components: {
            C1Label,
        },

        props: {
            selectedFilters: {
                type: Object,
                default: () => {},
            },
        },

        data() {
            return {
                options: [],
                attributeLabels: {
                    applyflow_custom_1 : window.afConfig?.applyflow_custom_1_label || '',
                    applyflow_custom_2 : window.afConfig?.applyflow_custom_2_label || '',
                    applyflow_custom_3 : window.afConfig?.applyflow_custom_3_label || '',
                    applyflow_custom_4 : window.afConfig?.applyflow_custom_4_label || '',
                },
                attributesData: [],
            };
        },

        created() {
            this.$_getSiteAttributes().then((res) => {
                if (res.data) {
                    for (const [key, value] of Object.entries(res.data)) {
                        const label = this.attributeLabels[key] ? this.attributeLabels[key] : 'Custom Attributes';

                        const setting_key = `${key}_show`;
                        if (window.afConfig[setting_key] === 'Yes') {
                            const attributes = value.map(a => ({
                                ...a,
                                value: a.value,
                            }));

                            this.attributesData.push({
                                key: key,
                                label: label,
                                attributeOptions: attributes,
                            });
                        }
                    }

                    this.loadSelectedAttributes();
                }
            });
        },

        computed: {
            ...mapState({
                customAttributes1(state) {
                    return (
                        state.search.searchPayload?.search_results?.aggregation?.applyflow_custom_1 || []
                    );
                },
                customAttributes2(state) {
                    return (
                        state.search.searchPayload?.search_results?.aggregation?.applyflow_custom_2 || []
                    );
                },
                customAttributes3(state) {
                    return (
                        state.search.searchPayload?.search_results?.aggregation?.applyflow_custom_3 || []
                    );
                },
                customAttributes4(state) {
                    return (
                        state.search.searchPayload?.search_results?.aggregation?.applyflow_custom_4 || []
                    );
                },

                showTaxonomyCount() {
                    return (window.afConfig?.hide_taxonomy_count === 'Yes') ? false : true;
                },

                // showCount() {
                //     return this.showTaxonomyCount();
                // },
            }),
        },

        watch: {
            selectedFilters() {
                this.loadSelectedAttributes();
            },
        },

        methods: {
            ...mapActions('attribute', {
                $_getSiteAttributes: 'getSiteAttributes',
            }),

            ...mapMutations('search', {
                $_STORE_SEARCH_FILTER_ATTRIBUTE: 'STORE_SEARCH_FILTER_ATTRIBUTE',
            }),

            loadSelectedAttributes() {
                const selectedFilters = {
                    applyflow_custom_1: this.selectedFilters.applyflow_custom_1 || [],
                    applyflow_custom_2: this.selectedFilters.applyflow_custom_2 || [],
                    applyflow_custom_3: this.selectedFilters.applyflow_custom_3 || [],
                    applyflow_custom_4: this.selectedFilters.applyflow_custom_4 || [],
                };

                const attributes = [...this.attributesData];
                attributes.forEach((attr) => {
                    const att_name = attr.key;
                    attr.attributeOptions.forEach((attrOp) => {
                        attrOp.is_selected = false;
                        selectedFilters[att_name].forEach((sa) => {
                            if (parseInt(sa.id) === parseInt(attrOp.id)) {
                                attrOp.is_selected = true;
                            }
                        });

                        attrOp.count = '0';
                        const aggrCustomAttributes = this[`customAttributes${att_name.charAt(att_name.length - 1)}`];
                        if (aggrCustomAttributes) {
                            aggrCustomAttributes.forEach((aggAttr) => {
                                if (parseInt(aggAttr.id) === parseInt(attrOp.id)) {
                                    attrOp.count = aggAttr.count;
                                }
                            });
                        }
                    });
                });

                this.attributesData = [...attributes];
            },

            onSelect(key, attributeOption) {
                attributeOption.is_selected = !attributeOption.is_selected;
                this.$_STORE_SEARCH_FILTER_ATTRIBUTE({ key: key, attributeOption: attributeOption });
            },

            toCamelCase(text, seperator) {
                const inputArray = text.split(seperator);
                let result = [];
                for(let i = 0 , len = inputArray.length; i < len; i++) {
                    let currentStr = inputArray[i];

                    let tempStr = currentStr.toLowerCase();
                    tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1);

                    result.push(tempStr);
                }

                return result.join(seperator);
            },
        },
    };
</script>
